import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import PageHeader from '../../components/ui/PageHeader';
import EmptyState from '../../components/ui/EmptyState';
import LoadingScreen from '../../components/ui/LoadingScreen';
import { useToast } from '../../contexts/ToastContext';
import { getTenantId } from '../../utils/ids';

function Usage() {
  const toast = useToast();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const response = await api.post('/partner/usage', { page: 1, limit: 500 });
        setCustomers(response.data.data?.customers || []);
      } catch (error) {
        toast.error('Failed to load usage');
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [toast]);

  if (loading) {
    return <LoadingScreen message="Loading usage..." />;
  }

  return (
    <div className="page">
      <PageHeader
        title="Billing & usage"
        description="Billing assignment plus per-customer rollup usage for the current month."
      />
      <div className="card">
        {customers.length === 0 ? (
          <EmptyState title="No customers" description="Add a customer to see billing assignment." />
        ) : (
          <div className="table-wrapper">
            <table className="data-table data-table--responsive">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Subdomain</th>
                  <th>Custom domain</th>
                  <th>Retail collector</th>
                  <th>In partner wholesale</th>
                  <th>Current total usage</th>
                  <th>Month usage</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((row) => (
                  <tr key={getTenantId(row) || row.subdomain}>
                    <td data-label="Customer">{row.name}</td>
                    <td data-label="Subdomain">{row.subdomain}</td>
                    <td data-label="Custom domain">{row.domain || '-'}</td>
                    <td data-label="Retail collector">{row.billing?.retailCollector || 'inherit'}</td>
                    <td data-label="In partner wholesale">
                      {row.billing?.includeInPartnerWholesale === false ? 'No' : 'Yes'}
                    </td>
                    <td data-label="Current total usage">{row.usage?.currentUsageTotal ?? 0}</td>
                    <td data-label="Month usage">
                      {row.usage?.monthlyUsageTotal ?? 0}
                      {row.usage?.periodKey ? ` (${row.usage.periodKey})` : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Usage;
